export class VirtualRepeaterRowComponent implements angular.IComponentOptions {
    public static $name: string = 'virtualRepeaterRow';

    public bindings: any = {};
    public controller = VirtualRepeaterRowController;
}

// tslint:disable-next-line: max-classes-per-file
export class VirtualRepeaterRowController implements angular.IComponentController {
    private static $inject: string[] = [
        '$element'
    ];

    constructor(
        private $element: angular.IAugmentedJQuery
    ) {
    }

    public $onInit() {
        // We want attributes to be applied to the original (outer) element, best place to do that is here
        this.$element.addClass('layout-column layout-gt-sm-row');
    }
}
